module.exports = __webpack_public_path__ + "static/media/appleAirTag.424e9c8d.jpg";